import { useId } from 'react';

import ExternalLinkModal from './ExternalLinkModal';
import { TextContentFragmentFragment } from '../../__generated__/graphql';
import Section from '../../layout/Section';
import { sanitizeHtml } from '../../utils/sanitzeHtml';
import { ContentBlock } from '../types';

import style from './text-content.module.css';

const TextContent: ContentBlock<TextContentFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.wsywig;
  const id = useId();

  if (!contentBlockProps?.textContent) {
    return null;
  }

  return (
    <>
      <Section
        backgroundColor={contentBlockProps.darkBackground ? 'black' : 'white'}
        id={contentBlockProps.sectionId}
        innerContainerClassName={style.container}
      >
        <div
          /* eslint-disable-next-line @typescript-eslint/naming-convention */
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(contentBlockProps.textContent) }}
          id={id}
        />
      </Section>

      {contentBlockProps.externalLinkModal && contentBlockProps.modal && (
        <ExternalLinkModal
          buttonText={contentBlockProps.modal.buttonText}
          clickListenerScopeId={id}
          description={contentBlockProps.modal.description}
          title={contentBlockProps.modal.title}
        />
      )}
    </>
  );
};

export default TextContent;
